import React from 'react';
import classNames from 'classnames';

import './AbstractIcon.scss';

const CircleCompleteIcon = ({ classes, size = 'md' }) => {
    return (
        <svg
            className={classNames('icon-root', classes)}
            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="8" fill="#25C16F"/>
            <path d="M4 8L6.66667 11L12 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default CircleCompleteIcon;
